export default function Testimonials() {
  const testimonials = [
    {
      name: 'Walt and Cindy',
      location: 'Home Remodel, Plainfield IL',
      review: 'Thanks Ken!  You have exceeded our expectations again!',
      rating: 5,
    },
    {
      name: 'J.C. and Katie',
      location: 'Bathroom, Lisle IL',
      review:
        'Thanks for all your great work! Katie and I are very happy with the results. I\'m sure we will have bigger and better projects down the road.',
      rating: 5,
    },
    {
      name: 'George',
      location: 'Basement renovation, Western Springs IL',
      review:
        'Thank you so much Ken. We really appreciate you. You are always there for us!',
      rating: 5,
    },
    {
      name: 'Cathy B.',
      location: 'Kitchen, Westchester IL',
      review: 'Thanks Ken! It looks great. I\'ll call you when I can do the basement.',
      rating: 5,
    },
    {
      name: 'Rich and Karen',
      location: 'Home Repair, Naperville IL',
      review: 'Thank you! I appreciate you taking care of this and always providing a great service.',
      rating: 5,
    },
    {
      name: 'Jeanine',
      location: 'Bathroom, Darien IL',
      review: 'Nice work! Thank you for everything.',
      rating: 5,
    },
  ];

  return (
    <section id="testimonials" className="py-20 bg-amber-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-12">
          <span className="inline-block bg-blue-600 text-white px-6 py-2 rounded-full text-sm font-semibold mb-4 whitespace-nowrap">
            CLIENT REVIEWS
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900">
            WHAT OUR CLIENTS SAY
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl p-8 shadow-md hover:shadow-xl transition-all duration-300"
            >
              <div className="flex items-center mb-6">
                <div>
                  <h4 className="font-bold text-gray-900 text-lg">
                    {testimonial.name}
                  </h4>
                  <p className="text-gray-500 text-sm">{testimonial.location}</p>
                </div>
              </div>
              <p className="text-gray-700 text-lg leading-relaxed mb-6">
                "{testimonial.review}"
              </p>
              <div className="flex space-x-1">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-blue-600 text-xl"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}